import React, {useEffect, useState} from 'react';
import {Link, useOutletContext} from 'react-router-dom';
import {getJobPostingMatchingList} from "../../api/jobApi";
import {JobPostingData} from "../../interface/JobPostingData";
import {EmptyState} from "../../components/common/EmptyStateProps";
import {setComma} from "../../utils/format";
import {getJobCostInfo} from "../../utils/jobCost";
import {Loading} from "../../components/common/Loading";


interface OutletContextType {
    workTypeFilter: string;
    setLoading: (loading: boolean) => void;
}

const MatchingTabPage = () => {
    const {workTypeFilter, setLoading} = useOutletContext<OutletContextType>();
    const [matchingList, setMatchingList] = useState<JobPostingData[]>([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const params = {workType: workTypeFilter};
                const res = await getJobPostingMatchingList(params);
                setMatchingList(res.data);
            } catch (error) {
                console.error("Failed to fetch data:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [workTypeFilter, setLoading]);
    if (!matchingList || matchingList.length === 0) {
        return <EmptyState message="매칭중인 공고가 없습니다."/>;
    }

    return (
        <>
            <main>
                <section>
                    <div className="inner-bottom">
                        {matchingList && matchingList.map((item) => (
                            <div className="round-box" key={item.jobPostingCode}>
                                <div className="round-body">
                                    <div className="info-row">
<span className="location-tit">
    {item.hospitalName || `${item.address || ''}`.trim()}
</span>
                                        <span className="applicant">지원 코디 : {item.coordinatorCount || 0}명</span>
                                    </div>
                                    <div className="info-row top-line">
                                        <span className="label">공고</span>
                                        <span className="cont">
                    {item.serviceType}
                </span>
                                    </div>

                                    <div className="info-row">
                                        <span className="label">어르신 이름</span>
                                        <span className="cont">{item.elderName}</span>
                                    </div>
                                    <div className="info-row">
                                        <span className="label">시작일</span>
                                        <span className="cont">{item.careStartDate}</span>
                                    </div>

                                    <div className="info-row">
                                        <span className="label">간병기간</span>
                                        <span className="cont">{item.careDayCount}일
                </span>
                                    </div>
                                    <div className="info-row top-line">
                                    <span className="label">비용(
                                        {item.workType === 'DAILY' ? '종일제' : '시급제'}
                                        )</span>
                                        <span
                                            className="cont">{item.workType === 'DAILY' ? '일급' : '시급'}/ {setComma(getJobCostInfo(item).cost)}원
                </span>
                                    </div>
                                    {getJobCostInfo(item).showOriginal && (
                                        <div className="info-row">
                                            <span className="label">최초 비용</span>
                                            <span className="cont">{item.workType === 'DAILY' ? '일급' : '시급'}/ {setComma(getJobCostInfo(item).original)}원</span>
                                        </div>
                                    )}
                                    <div className="info-row">
                                        <span className="label">비용협의</span>
                                        <span className="cont">{item.payNegotiable === 'Y' ? '가능' : '불가능'}</span>
                                    </div>
                                    <div className="info-row foot">
                                        <span className="status">{item.status === 'RECRUITING' ? '매칭대기' : '예약완료'}</span>
                                        <Link
                                            to={`/announcement/${item.jobPostingCode}`}
                                            className="foot-line-btn"
                                        >
                                            <i className="fa-solid fa-magnifying-glass"/>
                                            공고 자세히 보기
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            </main>
        </>
    );
};

export default MatchingTabPage;
